

$(function() {
    $('.body-template.slider_01').each(function() {
        var pageId = $(this).data('page');
        var swiper = new Swiper('.page-' + pageId + ' .swiper-container', {
            effect: 'cube',
            grabCursor: true,
            loop: true,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            pagination: '.swiper-pagination',
            paginationType: 'custom',
            preloadImages: false,
            lazyLoading: true,
            paginationCustomRender: function(swiper, current, total) {
                var pagination = '<div class="pagination-wrapper">';
                var width      = 100 / total;

                for (var i = 1; i <= total; i++) {
                    var active  = i == current ? 'active' : '';
                    pagination += '<span class="' + active + '" style="width: calc(' + width + '% - 5px);"></span>';
                }

                pagination += '</div>';
                return pagination;
            },
            cube: {
                shadow: true,
                slideShadows: true,
                shadowOffset: 20,
                shadowScale: 0.94
            },
            onSlideChangeStart: function() {
                if ($('.navbar-collapse').hasClass('in')) {
                    return;
                }
                //$('.navbar-fixed-top').removeClass('visible');
            }
        });
    });


    $('.body-template.slider_02').each(function() {
        var pageId = $(this).data('page');
        var swiper = new Swiper('.page-' + pageId + ' .swiper-container', {
            grabCursor: true,
            loop: true,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            pagination: '.swiper-pagination',
            paginationType: 'custom',
            paginationClickable: 'true',
            preloadImages: false,
            lazyLoading: true,
            autoplay: 4000,
            speed: 1000,
            paginationCustomRender: function(swiper, current, total) {
                var pagination = '<div class="pagination-wrapper">';
                var width      = 100 / total;

                for (var i = 1; i <= total; i++) {
                    var active  = i == current ? ' active' : '';
                    var span = '<span class="pagination-stripe' + active + '" data-slide="' + i + '" style="width: calc(' + width + '% - 5px);"><span class="colorbar"></span></span>';
                    pagination += span;
                }

                pagination += '</div>';

                return pagination;
            },

            onSlideChangeStart: function(current) {
                if ($('.navbar-collapse').hasClass('in')) {
                    return;
                }

                onSlider02SlideStart();
            },
            onAutoplayStop: function() {
                onSlider02AutoplayStop();
            }
        });
        swiperSlider_02 = swiper;
    });

    var swiperSlider_02;
    var slider02Interval;
    var slider02IntervalCounter = 0;
    var slider02Autoplay = true;

    function onSlider02AutoplayStop() {
        slider02Autoplay = false;
    }

    function onSlider02SlideStart() {
        clearInterval(slider02Interval);
        slider02IntervalCounter = 0;
        startNewStripeAnimation();
    }

    function startNewStripeAnimation() {
        var timeout= 48;
        if (!swiperSlider_02) {
            // de eerste slide staat er al
            timeout= 37;
        }
        slider02Interval = setInterval(function () {
            slider02IntervalCounter++;
            if (!slider02Autoplay) slider02IntervalCounter = 100; // autoplay stopped
            $('.body-template.slider_02 .pagination-stripe.active .colorbar').css('width', slider02IntervalCounter + '%');
        }, timeout);
    }

    $(document).on('click', '.pagination-stripe',  function() {
        var index = $(this).data('slide');
        swiperSlider_02.slideTo(index);
    });

    // $('.page-' + pageId + ' .swiper-container').mouseenter(function(){
    //     swiperSlider_02.stopAutoplay();
    // });
    //
    // $('.page-' + pageId + ' .swiper-container').mouseleave(function(){
    //     swiperSlider_02.startAutoplay();
    // });


    $('.body-template.slider_03').each(function() {
        var pageId = $(this).data('page');
        var swiper = new Swiper('.page-' + pageId + ' .swiper-container', {
            grabCursor: true,
            loop: false,
            effect: 'fade',
            pagination: '.swiper-pagination',
            paginationType: 'custom',
			paginationClickable: true,
            preloadImages: false,
            lazyLoading: true,
            paginationCustomRender: function(swiper, current, total) {
                var pagination = $('<div class="pagination-wrapper"/>');
                var width      = 100 / total;

                $(swiper.slides).each(function(index, slide) {
                    var $slide = $(slide);

                    if ($slide.hasClass('swiper-slide-duplicate')) {
                        return;
                    }

                    var active  = $slide.hasClass('swiper-slide-active') ? 'active' : '';
                    var title   = $slide.data('title');
                    var $item   = $(
                        '<span class="' + active + '" style="width: calc(' + width + '%);"> \ ' +
                            '<i class="circle"></i> \ ' +
                            '<hr class="left"><hr class="right"> \ ' +
                            '<div class="title">' + title + '</div> \ ' +
                        '</span>');

                    $item.click(function(e) {
                        e.preventDefault();
                        swiper.slideTo(index);
                    });
                    
                    pagination.append($item);
                });

                return pagination;
            },
            onSlideChangeStart: function() {
                if ($('.navbar-collapse').hasClass('in')) {
                    return;
                }
                //$('.navbar-fixed-top').removeClass('visible');
            }
        });
    });

    $('.products-list').each(function() {
        var $item = $(this);

        function initProductsSwiper() {
            var pageId = $item.data('page');
            var effect = $(window).width() > 768 ? 'fade' : 'slide';
            var windowWidth = $(window).width();
            var swiper = new Swiper('.page-' + pageId + ' .swiper-container', {
                grabCursor: true,
                loop: true,
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                pagination: '.swiper-pagination',
                effect: effect,
                fade: {
                    crossFade: true
                },
                preloadImages: false,
                lazyLoading: true,
                speed: effect == 'fade' ? 1200 : 500,
                freeModeMomentum: false,
                paginationCustomRender: function(swiper, current, total) {
                    var pagination = '<div class="pagination-wrapper">';
                    var width      = 100 / total;

                    for (var i = 1; i <= total; i++) {
                        var active  = i == current ? 'active' : '';
                        pagination += '<span class="' + active + '" style="width: calc(' + width + '% - 5px);"></span>';
                    }

                    pagination += '</div>';
                    return pagination;
                },
                onSlideChangeStart: function(swiper) {
                    if ($('.navbar-collapse').hasClass('in')) {
                        return;
                    }
                    //$('.navbar-fixed-top').removeClass('visible');
                },
                onSlideChangeEnd: function() {
                    summary.initAddButtons();
                },
                onSlideNextStart: function(swiper) {
                    var slidesTotal   = swiper.slides.length - 2;
                    var currentIndex  = swiper.realIndex;
                    var previousIndex = currentIndex - 1;

                    if (previousIndex < 0) {
                        previousIndex = slidesTotal - 1;
                    }

                    $('.page-' + pageId + ' .swiper-slide[data-swiper-slide-index=' + previousIndex + ']').addClass('swipe-out');
                    $('.page-' + pageId + ' .swiper-slide[data-swiper-slide-index=' + currentIndex + ']').removeClass('swipe-out').addClass('swipe-in');
                },
                onSlidePrevStart: function(swiper) {
                    var slidesTotal   = swiper.slides.length - 2;
                    var currentIndex  = swiper.realIndex;
                    var previousIndex = currentIndex + 1;

                    if (previousIndex > slidesTotal - 1) {
                        previousIndex = 0;
                    }

                    $('.page-' + pageId + ' .swiper-slide[data-swiper-slide-index=' + previousIndex + ']').addClass('swipe-out');
                    $('.page-' + pageId + ' .swiper-slide[data-swiper-slide-index=' + currentIndex + ']').removeClass('swipe-out').addClass('swipe-in');
                },
                onAfterResize: function(swiper) {
                    if ($(window).width() != windowWidth) {
                        swiper.destroy(true, true);
                        initProductsSwiper();
                    }
                }
            });

            $('.go-to-slide').off('click').on('click',function(e){
                e.preventDefault();

                var slide = $(this).attr('data-slide');
                swiper.slideTo(slide);

                $('.center-buttons .btn').removeClass('active');
                $('.center-buttons .btn-'+slide).addClass('active');

                return false;
            });
        }

        initProductsSwiper();
    });
});
